import {
  CHALLAN_WIDGET_LANDING,
  FASTAG_WIDGET_LANDING,
  HSRP_WIDGET_LANDING,
} from '@components/Product/ProductWidget/constants'

export const VAS_WIDGET_INPUT_PLACEHOLDER = 'e.g. MH05VF1234'
export const VEHICLE_DATA = 'vehicleData'
export const FASTAG_DATA = 'fastagData'
export const HSRP_DATA = 'hsrpData'
export const LOCAL_STORAGE_KEY = {
  [CHALLAN_WIDGET_LANDING]: VEHICLE_DATA,
  [FASTAG_WIDGET_LANDING]: FASTAG_DATA,
  [HSRP_WIDGET_LANDING]: HSRP_DATA,
}
export const VIEW_CHALLANS = 'View challans'
export const VIEW_FASTAG_BALANCE = 'View fastag balance'
export const BOOK_HSRP = 'Book your HSRP'

export const CHALLAN_WIDGET_INPUT = 'challanWidgetInput'
export const FASTAG_WIDGET_INPUT = 'fastagWidgetInput'
export const HSRP_WIDGET_INPUT = 'hsrpWidgetInput'
export const WIDGET_INPUT = 'widgetInput'
export const REG_NO_ERROR = 'Enter a valid registration number'
export const ERROR_BIKE_ENTERED = 'This is a bike number. Enter a valid car number.'
export const ERROR_COMMERTIAL_VEHICLE_ENTERED = 'Enter a valid car number.'
export const ERROR_FETCHING_VEHICLE = 'Please try again after some time.'
export const SERVER_ERROR_MESSAGE = 'Failure in fetch bill status after 15 attempts'
export const FETCHING_VEHICLE_DATA = 'Fetching vehicle data ...'

export const PREVIOUS_CHALLAN_CHECKS = 'Your previous challan checks'
export const PREVIOUS_FASTAG_CHECKS = 'Your previous FASTag checks'
export const PREVIOUS_HSRP_CHECKS = 'Your previous HSRP checks'
export const previousChecks = {
  [CHALLAN_WIDGET_LANDING]: PREVIOUS_CHALLAN_CHECKS,
  [FASTAG_WIDGET_LANDING]: PREVIOUS_FASTAG_CHECKS,
  [HSRP_WIDGET_LANDING]: PREVIOUS_HSRP_CHECKS,
}

export const ARROW_RIGHT_URL = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/arrow_right_a843cff96d.svg'
export const SEO_CHALLAN_FALLBACK_APPLINK = 'https://ackoctv.onelink.me/pNs0/xk00tycj'
export const SEM_PMAX_META_FALLBACK_APPLINK = 'https://ackoctv.onelink.me/pNs0/1vjlyiw0'
